<template>
  <div class="toggle-switch-container" :class="containerClass">
    <div class="toggle-switch" :class="switchClass">
      <input
        class="toggle-switch-input"
        type="checkbox"
        :id="inputId"
        :checked="modelValue"
        :disabled="disabled"
        @change="handleChange"
      >
      <label class="toggle-switch-label" :for="inputId"></label>
    </div>
    <label v-if="label" class="toggle-switch-text" :for="inputId">{{ label }}</label>
  </div>
</template>

<script>
let toggleId = 0

export default {
  name: 'ToggleSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // Visual variant: 'default', 'light', 'dark'
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'light', 'dark'].includes(value)
    },
    // Show background container
    showBackground: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputId: `toggle-switch-${++toggleId}`
    }
  },
  computed: {
    containerClass() {
      return {
        'toggle-switch-container--with-bg': this.showBackground,
        'toggle-switch-container--disabled': this.disabled
      }
    },
    switchClass() {
      return this.variant !== 'default' ? this.variant : ''
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('update:modelValue', event.target.checked)
      this.$emit('change', event.target.checked)
    }
  },
  emits: ['update:modelValue', 'change']
}
</script>

<style scoped>
.toggle-switch-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.toggle-switch-container--with-bg {
  background: #F5F5F5;
  padding: 15px;
  margin-bottom: 10px;
}

.toggle-switch-container--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  flex-shrink: 0;
}

.toggle-switch-input {
  display: none;
}

.toggle-switch-label {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 24px;
  background-color: #EEE;
  border-radius: 34px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.toggle-switch-label::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  top: 2px;
  left: 2px;
  background-color: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
}

.toggle-switch-input:checked + .toggle-switch-label {
  background-color: var(--color-primary, #6a16f0);
}

.toggle-switch-input:checked + .toggle-switch-label::before {
  transform: translateX(16px);
}

.toggle-switch-input:disabled + .toggle-switch-label {
  cursor: not-allowed;
}

/* Light variant */
.toggle-switch.light .toggle-switch-label {
  background-color: #BEBEBE;
}

.toggle-switch.light .toggle-switch-input:checked + .toggle-switch-label {
  background-color: #9B9B9B;
}

.toggle-switch.light .toggle-switch-input:checked + .toggle-switch-label::before {
  transform: translateX(6px);
}

/* Dark variant */
.toggle-switch.dark .toggle-switch-label {
  background-color: #4B4B4B;
}

.toggle-switch.dark .toggle-switch-input:checked + .toggle-switch-label {
  background-color: #717171;
}

.toggle-switch.dark .toggle-switch-input:checked + .toggle-switch-label::before {
  transform: translateX(16px);
}

.toggle-switch-text {
  color: #999;
  cursor: pointer;
  user-select: none;
}

.toggle-switch-container--disabled .toggle-switch-text {
  cursor: not-allowed;
}
</style>
